import qs from "qs";
import axios from "./http";
import store from "@/store";
import notification from "ant-design-vue/es/notification";
import { JPassConfig } from "@/common/config";

let host;
let viewHost;

// 开发环境时
if (process.env.NODE_ENV === "development") {
  host = "";
  viewHost = JPassConfig.devUrl;
} else {
  // 不是开发环境时，直接取当前页面的 origin
  let url = window.location.href;
  const parsedUrl = new URL(url);
  host = parsedUrl.origin;
  viewHost = parsedUrl.origin;
}

// 拼接
export const createServerApi = (serverName) => {
  return (url, flag = false) => {
    let result = serverName + url;
    // 下载文件,拼接完整地址
    if (flag) {
      result = host + result;
    }
    return result
  }
}

// 拼接
export const viewJpgApi = (hos) => {
  if(!hos) return
  return viewHost + hos
}

// 下载文件
export const downloadFile = (url, params) => {
  if (url === "" || url === undefined || url === null) return;
  const a = document.createElement("a");
  a.style.display = "none";
  a.target = "_blank";
  const queryString = qs.stringify(params);
  a.href = url + (queryString ? "?" + queryString : "");
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

// 获取接口返回数据,并弹出成功提示
export const successMsg = (responseData) => {
  const { success, message } = responseData.data;
  console.log("successMsg -- success", responseData)
  if (!success) {
    return "error";
  }
  if (success) {
    notification.success({
      key: "success",
      message: message,
    });
  }
  return "success";
};

// 取消请求
export const cancelRequests = () => {
  store.state.requestCancels.forEach((cancel) => {
    cancel && cancel();
  });
  store.state.requestCancels = [];
};
export default axios;
